import Vue from 'vue'
//@ts-ignore
import {format,Coordinate} from 'ol/coordinate'

const formatToGlider = (value:number,isLat:boolean) => {  
  return `${Math.abs(Math.trunc(value))}°${(60.0 * Math.abs(value % 1)).toFixed(4)}′ ${isLat?(value>=0?'N':'S'):(value>=0?'E':'W')}` 
}

Vue.filter('formatEPSG4326ToGlider', function(value:Coordinate, onlyLat:boolean|null=null) {
  if (value) {                    
    if(onlyLat == null) return `${formatToGlider(value[1],true)} ${formatToGlider(value[0],false)}`
    if(onlyLat) return formatToGlider(value[1],true)
    else return formatToGlider(value[0],false)
  }
})
